{
  "_comment": "The shared paint palette (Set 19). One source of truth for the paint gun's splatter colours, the paint-fish varieties, and the block-maker's pixel colours. Index is what crosses the wire (a paint colour is one small integer); the hex is resolved at the edges (renderer, swatches). Length is read dynamically (engine/palette.js) — fish/block-maker use however many there are. Index 32 is a vibrant purple added for the paint gun's vibrant set (Set 19.1).",
  "colors": [
    "#000000", "#1d2b53", "#7e2553", "#008751",
    "#ab5236", "#5f574f", "#c2c3c7", "#fff1e8",
    "#ff004d", "#ffa300", "#ffec27", "#00e436",
    "#29adff", "#83769c", "#ff77a8", "#ffccaa",
    "#291814", "#111d35", "#422136", "#125359",
    "#742f29", "#49333b", "#a28879", "#f3ef7d",
    "#be1250", "#ff6c24", "#a8e72e", "#00b543",
    "#065ab5", "#754665", "#ff6e59", "#ff9d81",
    "#a63dff"
  ]
}
